import type { GenealogyEvent, Relationship } from '../types.ts';
import { isEigenDeelname } from '../../shared/eigenGebeurtenis.mjs';

export interface MarriageInfo {
  event?: GenealogyEvent;
  date?: string;
  place?: string;
}

export function getMarriageEvent(
  rel: Relationship,
  events: GenealogyEvent[]
): GenealogyEvent | undefined {
  if (rel.type !== 'spousal' || !rel.personA || !rel.personB) return undefined;
  // #1947 — als partner, niet als vader of moeder van de bruid: anders kreeg een ouderpaar het
  // huwelijk van hun dochter als hun eigen huwelijk.
  const eigen = (e: GenealogyEvent, id: string) =>
    !!e.participants?.some((p) => p.personId === id && isEigenDeelname(e.type, p.role));
  return events.find(
    (e) => e.type === 'marriage' && eigen(e, rel.personA) && eigen(e, rel.personB)
  );
}

export function getMarriageInfo(rel: Relationship, events: GenealogyEvent[]): MarriageInfo {
  if (rel.type !== 'spousal') return {};

  const event = getMarriageEvent(rel, events);
  if (event) {
    return { event, date: event.date, place: event.placeName };
  }

  const legacyRel = rel as Relationship & {
    marriageDate?: string;
    marriagePlace?: string;
    date?: string;
    place?: string;
  };
  const legacyDate = legacyRel.marriageDate || legacyRel.date;
  const legacyPlace = legacyRel.marriagePlace || legacyRel.place;
  if (legacyDate || legacyPlace) {
    return { date: legacyDate, place: legacyPlace };
  }

  return {};
}
